const trustTypes = {
  AU: [
    {
      value: 1,
      label: 'screens.businessInformation.trustTypeOptions.cashManagement',
    },
    {
      value: 2,
      label: 'screens.businessInformation.trustTypeOptions.corporateUnit',
    },
    {
      value: 3,
      label: 'screens.businessInformation.trustTypeOptions.deceasedEstate',
    },
    {
      value: 4,
      label: 'screens.businessInformation.trustTypeOptions.discretionaryInvestment',
    },
    {
      value: 5,
      label: 'screens.businessInformation.trustTypeOptions.discretionaryServicesManagement',
    },
    {
      value: 6,
      label: 'screens.businessInformation.trustTypeOptions.discretionaryTrading',
    },
    {
      value: 7,
      label: 'screens.businessInformation.trustTypeOptions.firstHomeSaverAccounts',
    },
    {
      value: 8,
      label: 'screens.businessInformation.trustTypeOptions.fixed',
    },
    {
      value: 9,
      label: 'screens.businessInformation.trustTypeOptions.fixedUnit',
    },
    {
      value: 10,
      label: 'screens.businessInformation.trustTypeOptions.hybrid',
    },
    {
      value: 11,
      label: 'screens.businessInformation.trustTypeOptions.listedPublicUnit',
    },
    {
      value: 12,
      label: 'screens.businessInformation.trustTypeOptions.pooledSuperannuation',
    },
    {
      value: 13,
      label: 'screens.businessInformation.trustTypeOptions.publicTrading',
    },
    {
      value: 14,
      label: 'screens.businessInformation.trustTypeOptions.unlistedPublicUnit',
    },
    {
      value: 15,
      label: 'screens.businessInformation.trustTypeOptions.other',
    },
  ],
  NZ: [
    {
      value: 16,
      label: 'screens.businessInformation.trustTypeOptions.business',
    },
    {
      value: 17,
      label: 'screens.businessInformation.trustTypeOptions.charitable',
    },
    {
      value: 18,
      label: 'screens.businessInformation.trustTypeOptions.discretionary',
    },
    {
      value: 19,
      label: 'screens.businessInformation.trustTypeOptions.family',
    },
    {
      value: 15,
      label: 'screens.businessInformation.trustTypeOptions.other',
    },
  ],
};

export default trustTypes;
